module.exports = __webpack_public_path__ + "static/media/Delivery.d5f0443f.svg";